import { render } from "./verticalfw.vue?vue&type=template&id=19758074"
import script from "./verticalfw.vue?vue&type=script&lang=js"
export * from "./verticalfw.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__